global.modules.set({
  async init(context) {
    $('form.favorites', context).on('submit', function (e) {
      e.preventDefault();
      var thisForm = $(this);
      const formData = new FormData(thisForm[0]);
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        complete: null,
        beforeSend: null,
        success: function (data) {
          if (data && data.success) {
            thisForm.attr('action', function (index, attr) {
              return attr == '/favorites/add' ? '/favorites/remove' : '/favorites/add';
            });
            thisForm.find('.fav-btn').toggleClass('active');
          } else {
            global.showNotificationPopup(data.message, 'error');
          }
        }
      });
    });
    $('form.favorite_notes', context).on('submit', function (e) {
      e.preventDefault();
      var thisForm = $(this);
      const formData = new FormData(thisForm[0]);
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        complete: null,
        beforeSend: null,
        success: function (data) {
          if (data && data.success) {
            $('.listings_fav_btn', context).addClass('active');
            global.showNotificationPopup(data.message, 'success');
          } else {
            global.showNotificationPopup(data.message, 'error');
          }
        }
      });
    });
    $('form.user_form', context).on('submit', function (e) {
      e.preventDefault();
      var thisForm = $(this);
      const formData = new FormData(thisForm[0]);
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        complete: null,
        beforeSend: null,
        success: function (data) {
          var form = $(data);
          form.find('button[type="reset"]').on('click', function () {
            if ($(this).closest('.popup').hasClass('inner')) {
              $(this).closest('.popup').removeClass('active')
            } else {
              form.remove();
              $('body').removeClass('lock');
            }
          });
          $('body').addClass('lock')
          $('.main').append(form);
          global.modules.init(form);
          $('.change_password').on('click', function () {
            $('.change_password_fields').find('[name]').val('');
            $('.change_password_fields').slideToggle(500);
          })
          $('.change_custom_filter').on('click', function () {
            $('.change_custom_filter_fields').slideToggle(500);
          })
          $(document).on('mousedown', function (e) {
            if (!$(e.target).closest('.edit-profile-content').length) {
              form.remove();
              $('body').removeClass('lock');
            }
          });
          validateForm({
            selector: '#user_form',
            rules: {
              email: {
                required: true,
                email: true
              },
              firstName: {
                required: true
              },
              'phones[]': {
                required: true
              },
              lastName: {
                required: true
              },
              role_id: {
                required: true,
              },
              old_password: {
                required: true,
                minlength: 6
              },
              password: {
                required: true,
                minlength: 6
              },
              password_confirmation: {
                required: true,
                // equalTo: '[name="password"]',
                minlength: 6
              }
            }
          })
          validateForm({
            selector: '#company_form',
            rules: {}
          })
          validateForm({
            selector: '#user_settings',
            rules: {}
          })
        }
      });
    })
  }
})